// frontend/src/components/RetentionPolicyInfoModal.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function RetentionPolicyInfoModal() {
  const [show, setShow] = useState(false);

  return (
    <>
      <button
        onClick={() => setShow(true)}
        style={{
          background: "rgba(0, 255, 148, 0.1)",
          border: "1px solid #00FF94",
          color: "#00FF94",
          borderRadius: "50%",
          width: "24px",
          height: "24px",
          fontSize: "0.85rem",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          transition: "all 0.3s ease",
          boxShadow: "0 0 8px rgba(0, 255, 148, 0.2)",
        }}
        onMouseOver={(e) => {
          e.target.style.background = "rgba(0, 255, 148, 0.25)";
          e.target.style.boxShadow = "0 0 15px rgba(0, 255, 148, 0.5)";
          e.target.style.transform = "scale(1.1)";
        }}
        onMouseOut={(e) => {
          e.target.style.background = "rgba(0, 255, 148, 0.1)";
          e.target.style.boxShadow = "0 0 8px rgba(0, 255, 148, 0.2)";
          e.target.style.transform = "scale(1)";
        }}
        title="Politique de Conservation & Conformité (RCDE)"
      >
        i
      </button>

      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.85)",
            backdropFilter: "blur(6px)",
            zIndex: 99999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
          onClick={() => setShow(false)}
        >
          <div
            style={{
              background: "rgba(10, 18, 30, 0.98)",
              border: "1px solid rgba(0, 255, 148, 0.5)",
              padding: "32px",
              borderRadius: "20px",
              maxWidth: "580px",
              width: "100%",
              boxShadow: "0 0 50px rgba(0, 255, 148, 0.2)",
              color: "#fff",
              position: "relative",
              maxHeight: "90vh",
              overflowY: "auto",
              fontFamily: "'Inter', sans-serif",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px", borderBottom: "1px solid rgba(255,255,255,0.08)", paddingBottom: "16px" }}>
              <span style={{ fontSize: "1.6rem" }}>🔒</span>
              <h2
                style={{
                  margin: 0,
                  color: "#00FF94",
                  fontSize: "1.3rem",
                  letterSpacing: "1px",
                }}
              >
                Moteur de Conservation (RCDE)
              </h2>
            </div>

            <div style={{ textAlign: "left", lineHeight: "1.6", fontSize: "0.92rem", color: "#ddd" }}>
              <p>
                Le <strong>Retention & Compliance Decision Engine (RCDE)</strong> qualifie automatiquement chaque enregistrement et preuve cryptographique au sein de notre coffre d'intégrité (Vault).
              </p>

              <h3 style={{ color: "#ffd369", fontSize: "1rem", marginTop: "20px", marginBottom: "8px" }}>
                🛡️ Sécurité Absolue "Fail-Closed"
              </h3>
              <p>
                Aucune donnée n'est purgée, anonymisée ou archivée off-chain tant qu'une signature ou empreinte d'ancrage n'a pas été confirmée et validée de manière immuable <strong>on-chain (sur la blockchain)</strong>.
              </p>

              <h3 style={{ color: "#ffd369", fontSize: "1rem", marginTop: "20px", marginBottom: "8px" }}>
                ⚖️ Privacy by Design (Art. 25 RGPD)
              </h3>
              <p>
                La plateforme applique de manière stricte le principe de minimisation des données, assurant que seules les métadonnées techniques non-nominatives sont conservées à long terme.
              </p>
            </div>

            <div style={{ display: "flex", gap: "12px", marginTop: "30px" }}>
              <Link
                to="/retention-policy"
                onClick={() => setShow(false)}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: "linear-gradient(90deg, #00FF94 0%, #00e5ff 100%)",
                  color: "#000",
                  border: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  textDecoration: "none",
                  textAlign: "center",
                  fontSize: "0.9rem",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = "scale(1.02)";
                  e.target.style.boxShadow = "0 0 15px rgba(0, 255, 148, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "none";
                }}
              >
                Consulter la Politique Complète
              </Link>
              
              <button
                onClick={() => setShow(false)}
                style={{
                  padding: "12px 24px",
                  background: "rgba(255,255,255,0.06)",
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.15)",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "0.9rem",
                  transition: "background 0.2s",
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.12)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.06)";
                }}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
